import React, { Component } from "react";

import print from "../../assets/print.png"
import zoom from "../../assets/zoom.png"
import download from "../../assets/download.png"
import MyInput from "../../components/MyInput";
import Dropdown from "../../components/Dropdown";
import DeviceDropDown from "../../components/DeviceDropDown";
import { addDevices, adduserPost, editdevice, editUser, getRoles, getStores, getDevices } from "../../Path/Path";
import { withRouter } from "../../components/withRouter";
import { v4 as uuidv4 } from 'uuid';
import { toast } from "react-toastify"
import Loader from "../../components/Loader";
import { Autocomplete, TextField } from '@mui/material';
import BackButton from "../../components/BackButton";
class AddDevice extends Component {
    constructor(props) {
        super(props)

        this.state = {
            server: "",
            username: "",
            password: "",
            deviceuniqueid: "",
            status: "",
            storeName: "",
            role: [],
            slectrole: "",
            store: [],
            storeNameList: [],
            storeName: "",
            dropStore: "",
            dropRole: "",
            selectstore: "",
            data: [],
            active: "",
            showStatus: false,
            showRole: false,
            showStoreId: false,
            loading: false,
            serverProtocol: '',
            flowServerProtocol: '',
            flowServerIp: '',
            storeItems: [],
            existingDevices: [],
            errors: {
                username: "",
                password: "",
                server: "",
                flowServerIp: "",
                deviceuniqueid: ""
            }
        }
    }

    async componentDidMount() {
        this.setState({ loading: true })
        const store = await getStores();
        const storesName = store.map((elem) => elem.storename)
        const existingDevices = await getDevices();
        this.setState({ storeNameList: storesName, storeItems: store, existingDevices: existingDevices || [] })
        this.setState({ loading: false })
        if (this.props.location.state?.item) {

            const item = this.props.location.state.item
            console.log('item: ', item);
            this.setState({
                username: item.userName,
                server: item.server,
                password: item.password,
                deviceuniqueid: item.deviceUniqueID,
                serverProtocol: item.serverProtocol,
                flowServerProtocol: item.flowServerProtocol,
                flowServerIp: item.flowServerIp,
                // active: item.active,
                active: item?.active === true ? "Active" : "Deactive",
                storeName: item?.siteId,
                store: item.siteId,
                dropStore: item?._id,
            })
        }
    }

    // IP Address Validation
    validateIPAddress = (ip) => {
        const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        return ipRegex.test(ip);
    }

    // Check for duplicate username
    checkDuplicateUsername = (username) => {
        if (!username) return false;
        const currentItemId = this.props.location?.state?.item?._id;
        const duplicate = this.state.existingDevices.find(
            device => device.userName?.toLowerCase() === username.toLowerCase() && device._id !== currentItemId
        );
        return !!duplicate;
    }

    // Check for duplicate device unique ID
    checkDuplicateDeviceID = (deviceId) => {
        if (!deviceId) return false;
        const currentItemId = this.props.location?.state?.item?._id;
        const duplicate = this.state.existingDevices.find(
            device => device.deviceUniqueID?.toLowerCase() === deviceId.toLowerCase() && device._id !== currentItemId
        );
        return !!duplicate;
    }

    // Password strength validation
    validatePassword = (password) => {
        if (!password) return { valid: false, message: "Password is required" };
        if (password.length < 6) {
            return { valid: false, message: "Password must be at least 6 characters long" };
        }
        // Check for weak passwords (all numbers or simple patterns)
        if (/^[0-9]+$/.test(password)) {
            return { valid: false, message: "Password is too weak. Use a combination of letters, numbers, and special characters" };
        }
        if (/^(.)\1+$/.test(password)) {
            return { valid: false, message: "Password is too weak. Use a combination of letters, numbers, and special characters" };
        }
        return { valid: true, message: "" };
    }

    // Sanitize input - remove special characters (allow alphanumeric, spaces, dots, hyphens, underscores)
    sanitizeInput = (value, field) => {
        // For IP addresses, allow dots and numbers
        if (field === 'server' || field === 'flowServerIp') {
            return value.replace(/[^0-9.]/g, '');
        }
        // For username, allow alphanumeric, dots, hyphens, underscores
        if (field === 'username') {
            return value.replace(/[^a-zA-Z0-9._-]/g, '');
        }
        // For device unique ID, allow alphanumeric, dots, hyphens, underscores
        if (field === 'deviceuniqueid') {
            return value.replace(/[^a-zA-Z0-9._-]/g, '');
        }
        // For password, allow most characters but restrict some dangerous ones
        if (field === 'password') {
            return value.replace(/[<>'"]/g, '');
        }
        return value;
    }

    sendHandler = async () => {
        // Reset errors
        const errors = {
            username: "",
            password: "",
            server: "",
            flowServerIp: "",
            deviceuniqueid: ""
        };

        let hasErrors = false;

        // Validate username
        if (this.state.username === "") {
            errors.username = "Enter User Name";
            hasErrors = true;
        } else if (this.checkDuplicateUsername(this.state.username)) {
            errors.username = "Device name already exists. Please use a different name.";
            hasErrors = true;
        }

        // Validate password
        if (this.state.password === "") {
            errors.password = "Enter Password";
            hasErrors = true;
        } else {
            const passwordValidation = this.validatePassword(this.state.password);
            if (!passwordValidation.valid) {
                errors.password = passwordValidation.message;
                hasErrors = true;
            }
        }

        // Validate Server IP
        if (this.state.server === "") {
            errors.server = "Enter Server IP";
            hasErrors = true;
        } else if (!this.validateIPAddress(this.state.server)) {
            errors.server = "Invalid Server IP format. Please enter a valid IP address (e.g., 192.168.1.1)";
            hasErrors = true;
        }

        // Validate Flow Server IP
        if (this.state.flowServerIp === "") {
            errors.flowServerIp = "Enter Flow Server IP";
            hasErrors = true;
        } else if (!this.validateIPAddress(this.state.flowServerIp)) {
            errors.flowServerIp = "Invalid Flow Server IP format. Please enter a valid IP address (e.g., 192.168.1.1)";
            hasErrors = true;
        }

        // Validate Device Unique ID
        if (this.state.deviceuniqueid === "") {
            errors.deviceuniqueid = "Enter Device Unique ID";
            hasErrors = true;
        } else if (this.state.deviceuniqueid.length > 255) {
            errors.deviceuniqueid = "Device Unique ID must not exceed 255 characters";
            hasErrors = true;
        } else if (this.checkDuplicateDeviceID(this.state.deviceuniqueid)) {
            errors.deviceuniqueid = "Device Unique ID already exists. Please use a different ID.";
            hasErrors = true;
        }

        // Validate other required fields
        if (this.state.serverProtocol === "") {
            toast.warn("Select Server Protocol");
            hasErrors = true;
        }
        if (this.state.flowServerProtocol === "") {
            toast.warn("Select Flow Server Protocol");
            hasErrors = true;
        }
        if (this.state.active === "") {
            toast.warn("Select Status");
            hasErrors = true;
        }
        if (this.state.storeName === "") {
            toast.warn("Select Store");
            hasErrors = true;
        }

        // Update errors state
        this.setState({ errors });

        // If there are errors, show the first one and return
        if (hasErrors) {
            // const firstError = Object.values(errors).find(err => err !== "");
            // if (firstError) {
            //     toast.warn(firstError);
            // }
            return;
        }

        const storeId = this.state.storeItems.find(i => i.storename === this.state.storeName)
        console.log('storeId: ', storeId);
        const body = {
            "userName": this.state.username,
            "password": this.state.password,
            "server": this.state.server,
            "uuid": uuidv4(),
            "active": this.state.active === "Active" ? true : false,
            "deviceUniqueID": this.state.deviceuniqueid,
            "siteId": storeId?._id,
            "serverProtocol": this.state.serverProtocol,
            "flowServerProtocol": this.state.flowServerProtocol,
            "flowServerIp": this.state.flowServerIp,
            "siteId": this.state.storeName
        }

        if (this.props.location?.state?.item) {
            try {
                await editdevice(body, this.props.location.state.item._id)
                toast.success("Device edited successfully")
                this.props.history("/devices")
            } catch (err) {
                toast.warn(err?.response?.data?.error || "Something went wrong")
            }
        } else {
            try {
                await addDevices(body);
                toast.success("Device added successfully")
                this.props.history("/devices")
            } catch (err) {
                if (err?.response?.status === 409) {
                    toast.warn(err?.response?.data?.error || "Device already exists")
                } else {
                    toast.warn(err?.response?.data?.error || "Something went wrong")
                }
            }
        }
    }

    render() {
        // console.log(this.state.fil._id);
        const isEdit = this.props.location?.state?.item;

        return (
            <>
                <Loader loading={this.state.loading} />
                <div className="dashboard-main">
                    <div className="dashboard-top">
                        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                            <BackButton />
                            <p className="stock-count" style={{ margin: 0 }}>{isEdit ? "Edit Device" : "Add Device"}</p>
                        </div>
                        <div style={{ display: "flex", width: "13%", justifyContent: "space-between", marginTop: "0.3%" }}>
                            <div >
                                <img src={zoom}></img>
                            </div>
                            <div>
                                <img src={print}></img>
                            </div>
                            <div>
                                <img width={30} height={30} src={download}></img>
                            </div>
                        </div>
                    </div>
                    <div style={{ paddingInline: 20, marginTop: 20, display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", flexWrap: 'wrap' }}>
                        {/* <div> <p className="filter-text">Filters</p></div> */}

                        <TextField
                            sx={{ width: 235 }}
                            defaultValue={this.state.username}
                            placeholder="User Name"
                            value={this.state.username}
                            size={'small'}
                            inputProps={{ maxLength: 50 }}
                            error={!!this.state.errors.username}
                            helperText={this.state.errors.username}
                            onChange={(data) => {
                                const sanitized = this.sanitizeInput(data.target.value, 'username');
                                this.setState({ 
                                    username: sanitized,
                                    errors: { ...this.state.errors, username: "" }
                                });
                            }} 
                            id="outlined-basic" 
                            label="User Name" 
                            variant="outlined" />
                        <TextField
                            sx={{ width: 235 }}
                            defaultValue={this.state.password}
                            placeholder="Password"
                            value={this.state.password}
                            size={'small'}
                            type="password"
                            error={!!this.state.errors.password}
                            helperText={this.state.errors.password}
                            onChange={(data) => {
                                const sanitized = this.sanitizeInput(data.target.value, 'password');
                                this.setState({ 
                                    password: sanitized,
                                    errors: { ...this.state.errors, password: "" }
                                });
                            }} 
                            id="outlined-basic" 
                            label="Password" 
                            variant="outlined" />
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            size={'small'}
                            value={this.state.serverProtocol}
                            options={["http", "https"]}
                            onChange={(e, v) => this.setState({ serverProtocol: (v === null || v === undefined) ? '' : v })}
                            sx={{ width: 235 }}
                            renderInput={(params) => <TextField
                                {...params} label="Server Protocol" />}
                        />
                        <TextField
                            sx={{ width: 235 }}
                            defaultValue={this.state.server}
                            value={this.state.server}
                            placeholder="Server IP"
                            size={'small'}
                            error={!!this.state.errors.server}
                            helperText={this.state.errors.server}
                            onChange={(data) => {
                                const sanitized = this.sanitizeInput(data.target.value, 'server');
                                this.setState({ 
                                    server: sanitized,
                                    errors: { ...this.state.errors, server: "" }
                                });
                            }} 
                            id="outlined-basic" 
                            label="Server IP" 
                            variant="outlined" />
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            size={'small'}
                            value={this.state.flowServerProtocol}
                            options={["http", "https"]}
                            onChange={(e, v) => this.setState({ flowServerProtocol: (v === null || v === undefined) ? '' : v })}
                            sx={{ width: 235 }}
                            renderInput={(params) => <TextField
                                {...params} label="Flow Server Protocol" />}
                        />




                    </div>

                    <div style={{ paddingInline: 20, marginTop: 15, display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "100%", flexWrap: 'wrap' }}>
                        <TextField
                            sx={{ width: 235 }}
                            defaultValue={this.state.flowServerIp}
                            placeholder="Flow Server IP"
                            value={this.state.flowServerIp}
                            size={'small'}
                            error={!!this.state.errors.flowServerIp}
                            helperText={this.state.errors.flowServerIp}
                            onChange={(data) => {
                                const sanitized = this.sanitizeInput(data.target.value, 'flowServerIp');
                                this.setState({ 
                                    flowServerIp: sanitized,
                                    errors: { ...this.state.errors, flowServerIp: "" }
                                });
                            }} 
                            id="outlined-basic" 
                            label="Flow Server IP" 
                            variant="outlined" />
                        <TextField
                            sx={{ width: 235 }}
                            defaultValue={this.state.deviceuniqueid}
                            value={this.state.deviceuniqueid}
                            placeholder="Device Unique ID"
                            size={'small'}
                            error={!!this.state.errors.deviceuniqueid}
                            helperText={this.state.errors.deviceuniqueid}
                            inputProps={{ maxLength: 255 }}
                            onChange={(data) => {
                                const sanitized = this.sanitizeInput(data.target.value, 'deviceuniqueid');
                                this.setState({ 
                                    deviceuniqueid: sanitized,
                                    errors: { ...this.state.errors, deviceuniqueid: "" }
                                });
                            }} 
                            id="outlined-basic" 
                            label="Device Unique ID" 
                            variant="outlined" />

                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            size={'small'}
                            value={this.state.active}
                            options={["Active", "Deactive"]}
                            onChange={(e, v) => this.setState({ active: (v === null || v === undefined) ? '' : v })}
                            sx={{ width: 235 }}
                            renderInput={(params) => <TextField
                                {...params} label="Status" />}
                        />
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            size={'small'}
                            value={this.state.storeName}
                            options={this.state.storeItems?.map((item => item?.Warehouse)).reduce((noDupArr, entry) => {
                                if (noDupArr?.includes(entry)) {
                                    return noDupArr;
                                } else {
                                    return [...noDupArr, entry];
                                }
                            }, []).filter((item => item !== null && item !== undefined ))}
                            onChange={(e, v) => this.setState({ storeName: v === null ? '' : v })}
                            sx={{ width: 235 }}
                            renderInput={(params) => <TextField
                                {...params} label="Stores" />}
                        />

                    </div>
                    <div style={{ paddingLeft: 20, marginTop: 20, marginBottom: 20 }} >
                        <button className="run-btn" onClick={() => this.sendHandler()}> <p className="run-text"> {isEdit ? "Edit Device" : "Add Device"}</p></button>
                    </div>
                </div>

            </>
        )
    }
}

export default withRouter(AddDevice);